import React from 'react';
import './LegalPage.css';

function TermsOfServicePage() {
  const lastUpdated = '22-04-2026';

  return (
    <div className="legal-page">
      <div className="legal-page__container">
        <a href="/" className="legal-page__close" aria-label="Close and return to avatar experience">
          X
        </a>
        <h1 className="legal-page__title">Terms of Service</h1>
        <p className="legal-page__intro">
          Please read these Terms carefully before using the service.
        </p>

        <section className="legal-page__section">
          <p>
            <strong>Last Updated:</strong> {lastUpdated}
          </p>

          <h2>1. Nature of Service: Historical Simulation</h2>
          <p>
            You acknowledge that this service provides AI-generated simulations of historical
            figures such as Abraham Lincoln.
          </p>
          <ul>
            <li>
              <strong>Not a Real Person:</strong> The avatar is a digital representation and not a
              sentient being, nor the actual historical figure.
            </li>
            <li>
              <strong>Entertainment &amp; Education Only:</strong> Interactions are for
              informational and entertainment purposes only. The AI may generate
              &quot;hallucinations&quot; (historical inaccuracies).
            </li>
            <li>
              <strong>No Professional Advice:</strong> The &quot;Lincoln&quot; avatar cannot provide
              valid legal, medical, or professional advice.
            </li>
          </ul>

          <h2>2. Voice Interaction &amp; User Conduct</h2>
          <p>
            This service relies primarily on voice input (&quot;Speak&quot;) and audio output.
          </p>
          <ul>
            <li>
              <strong>Consent to Record:</strong> By clicking &quot;Speak&quot; or enabling the
              microphone, you explicitly consent to the real-time recording and transmission of your
              voice to our third-party processors for conversion into text.
            </li>
            <li>
              <strong>Appropriate Environment:</strong> You agree to use the voice feature only in
              settings where you have the right to record audio. You agree not to capture the
              voices of non-consenting third parties or minors.
            </li>
            <li>
              <strong>Prohibited Content:</strong> You may not use the voice feature to broadcast
              hate speech, obscenity, or illegal content.
            </li>
          </ul>

          <h2>3. Intellectual Property</h2>
          <p>
            Action Tour Guide owns the specific AI implementation, the &quot;Afterlife Bot&quot;
            branding, and the custom prompt engineering used to simulate the historical figure. The
            historical likeness of this historical figure is in the public domain; however, our
            specific digital rendering may be protected.
          </p>

          <h2>4. Disclaimer of Warranties</h2>
          <p>
            The service is provided &quot;as is.&quot; We do not guarantee that the voice recognition
            will accurately transcribe your speech or that the &quot;Mute&quot; function will
            instantly silence all audio streams due to internet latency.
          </p>

          <h2>5. Limitation of Liability</h2>
          <p>
            To the fullest extent permitted by law, Action Tour Guide is not liable for any errors
            in transcription, historical inaccuracies, or reliance on the AI&apos;s statements.
          </p>
        </section>

        <div className="legal-page__actions">
          <a href="/privacy-policy" className="legal-page__link legal-page__link--secondary">
            View Privacy Policy
          </a>
          <a href="/" className="legal-page__link">
            Back to Avatar Experience
          </a>
        </div>
      </div>
    </div>
  );
}

export default TermsOfServicePage;
